<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-20" :bodyStyle="{ paddingTop: '20px' }">
      <template #title>
        <h6><a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a>Design Form</h6>
        <p class="mt-0 mb-0">
          <!-- Booking should be apply up to 10 days before you will use or promote event -->
          <!-- In case of booking a car after working hours, the admin will arrange
          the car within working hours of the following day (9:00 - 16:00). -->
        </p>
        <p class="mt-0 mb-0">
          For urgent matter, please contact 02-700-5000 Ext.3102
        </p>
      </template>

      <a-form :layout="'horizontal'" :form="form">
        <a-form-item label="Email" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-input v-model="formData.contact_mail" placeholder="enter email ..." v-decorator="[
            'contact_mail',
            { initialValue: formData.contact_mail, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>

        <a-form-item label="Contact" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-input v-model="formData.contact_tel" placeholder="enter contact ..." v-decorator="[
            'formData.contact_tel',
            { initialValue: formData.contact_tel, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>

        <a-form-item label="Details / Content of Printing" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formData.detail_of_design" />
        </a-form-item>

        <!-- Event date -->
        <a-form-item label="Deadline" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-date-picker class="mr-10" v-model="formData.deadline_date" :disabled-date="disabledDate" v-decorator="[
            'formData.deadline_date',
            { initialValue: formData.deadline_date, rules: [{ required: true, message: 'Please input your data.' }] },
          ]" />
        </a-form-item>
        <!-- Event date -->

        
        

        

        <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" :colon="false">
          <span slot="label"><span class="text-danger">*</span> Category</span>
          
        </a-form-item>

        <a-form-item label="Digital Size" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-button type="dashed" block @click="addData('size_of_design')">
            + Add
          </a-button>
          <span v-for="(data, i) in formData.size_of_design">
            <a-row class="mt-10">
              <a-col :span="12" style="text-align: left;">
                {{ formData.size_of_design.length > 1 ? i + 1 : '' }}
              </a-col>
              <a-col :span="12" style="text-align: right;">
                
                <a-button type="link" class="text-center" @click="removeItem(index, 'size_of_design')">
                  <a-icon style="font-size: 20px; color: red" type="delete" />
                </a-button>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="6">
                <a-select show-search placeholder="select size of printing ..." option-filter-prop="children"
                  v-model="data.sizePrinting" @change="onChangeSizeDigitalMedia(i, data.sizePrinting)">
                  <a-select-option v-for="(item, index) in optionSizeDigitalMedia" :key="'size_printing' + index"
                    :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="3" style="text-align: right;">
                <b>Amount : </b>
              </a-col>
              <a-col :span="6" style="margin-left: 2px;">
                <a-input type="number" v-model="data.amount" min="0" placeholder="enter amount..." />
              </a-col>
            </a-row>

            <a-row class="mb-10">
              <a-col :span="6">
                <a-input type="number" v-model="data.width" placeholder="enter width..."
                  :disabled="data.sizePrinting != 'Custom'" />
              </a-col>
              <a-col :span="1" style="text-align: center;">
                <b>x</b>
              </a-col>
              <a-col style="margin-left: 2px;" :span="6">
                <a-input type="number" v-model="data.height" placeholder="enter height..."
                  :disabled="data.sizePrinting != 'Custom'" />
              </a-col>
              <a-col :span="2" style="text-align: right;">
                <b>pixels.</b>
              </a-col>
            </a-row>

            <a-row class="mb-10">
              <a-col :span="24">
                <b>Oreintation : </b>
                <a-radio-group style="margin-left: 10px;" v-model="data.isPortrait">
                  <a-radio :value="true">
                    <img :width="100" src="../../../../../public/images/portrait_icon.png" alt="imag_form-design_1" />
                  </a-radio>
                  <a-radio :value="false">
                    <img :width="100" src="../../../../../public/images/landscape_icon.png" alt="imag_form-design_2" /> </a-radio>
                </a-radio-group>
              </a-col>
            </a-row>

            

            <hr>
          </span>
        </a-form-item>
        <a-form-item label="Print Size" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-button type="dashed" block @click="addData('print_of_media')">
            + Add
          </a-button>
          
          <span v-for="(data, i) in formData.print_of_media">
            <a-row class="mt-10">
              <a-col :span="12" style="text-align: left;">
                {{ formData.print_of_media.length > 1 ? i + 1 : '' }}
              </a-col>
              <a-col :span="12" style="text-align: right;">
                
                <a-button type="link" class="text-center" @click="removeItem(index, 'print_of_media')">
                  <a-icon style="font-size: 20px; color: red" type="delete" />
                </a-button>
                <!-- </a-popconfirm> -->
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="6">
                <a-select show-search placeholder="select size of printing ..." option-filter-prop="children"
                  v-model="data.sizePrinting" @change="onChangeSizePrint(i, data.sizePrinting, 'print_of_media')">
                  <a-select-option v-for="(item, index) in optionSizePrinting" :key="'size_printing' + index"
                    :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="3" style="text-align: right;">
                <b>Amount : </b>
              </a-col>
              <a-col style="margin-left: 2px;" :span="6">
                <a-input type="number" v-model="data.amount" placeholder="enter amount..." />
              </a-col>
            </a-row>

            <a-row class="mb-10">
              <a-col :span="6">
                <a-input type="number" v-model="data.width" placeholder="enter width..."
                  :disabled="data.sizePrinting != 'Custom'" />
              </a-col>
              <a-col :span="1" style="text-align: center;">
                <b>x</b>
              </a-col>
              <a-col style="margin-left: 2px;" :span="6">
                <a-input type="number" v-model="data.height" placeholder="enter height..."
                  :disabled="data.sizePrinting != 'Custom'" />
              </a-col>
              <a-col :span="3" style="text-align: center;">
                <b>Unit : </b>
              </a-col>
              <a-col :span="4">
                <a-select show-search placeholder="unit ..." option-filter-prop="children" v-model="data.unitType"
                  :disabled="data.sizePrinting != 'Custom'">
                  <a-select-option v-for="(item, index) in optionUnit" :key="'type_unit' + index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>

            <a-row class="mb-10">
              <a-col :span="24">
                <b>Oreintation : </b>
                <a-radio-group style="margin-left: 10px;" v-model="data.isPortrait">
                  <a-radio :value="true">
                    <img :width="100" src="../../../../../public/images/portrait_icon.png" alt="imag_form-design_3" />
                  </a-radio>
                  <a-radio :value="false">
                    <img :width="100" src="../../../../../public/images/landscape_icon.png" alt="imag_form-design_4" /> </a-radio>
                </a-radio-group>
              </a-col>
            </a-row>

            <hr>
          </span>
        </a-form-item>

        <a-form-item label="Print (Option)" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-button type="dashed" block @click="addData('print_option')">
            + Add
          </a-button>
          <span v-for="(data, i) in formData.print_option">
            <a-row class="mt-10">
              <a-col :span="12" style="text-align: left;">
                {{ formData.print_option.length > 1 ? i + 1 : '' }}
              </a-col>
              <a-col :span="12" style="text-align: right;">
                
                
                <a-button type="link" class="text-center" @click="removeItem(index, 'print_option')">
                  <a-icon style="font-size: 20px; color: red" type="delete" />
                </a-button>
                <!-- </a-popconfirm> -->
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="6">
                <a-select show-search placeholder="select size of printing ..." option-filter-prop="children"
                  v-model="data.sizePrinting" @change="onChangeSizePrint(i, data.sizePrinting, 'print_option')">
                  <a-select-option v-for="(item, index) in optionSizePrinting" :key="'size_printing' + index"
                    :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="3" style="text-align: right;">
                <b>Amount : </b>
              </a-col>
              <a-col style="margin-left: 2px;" :span="6">
                <a-input type="number" v-model="data.amount" placeholder="enter amount..." />
              </a-col>
            </a-row>
            <a-row class="mb-10">
              <a-col :span="6">
                <a-input type="number" v-model="data.width" placeholder="enter width..."
                  :disabled="data.sizePrinting != 'Custom'" />
              </a-col>
              <a-col :span="1" style="text-align: center;">
                <b>x</b>
              </a-col>
              <a-col style="margin-left: 2px;" :span="6">
                <a-input type="number" v-model="data.height" placeholder="enter height..."
                  :disabled="data.sizePrinting != 'Custom'" />
              </a-col>
              <a-col :span="3" style="text-align: center;">
                <b>Unit : </b>
              </a-col>
              <a-col :span="4">
                <a-select show-search placeholder="unit ..." option-filter-prop="children" v-model="data.unitType"
                  :disabled="data.sizePrinting != 'Custom'">
                  <a-select-option v-for="(item, index) in optionUnit" :key="'type_unit' + index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>

            <a-row class="mb-10">
              <a-col :span="24">
                <b>Oreintation : </b>
                <a-radio-group style="margin-left: 10px;" v-model="data.isPortrait">
                  <a-radio :value="true">
                    <img :width="100" src="../../../../../public/images/portrait_icon.png" alt="imag_form-design_5" />
                  </a-radio>
                  <a-radio :value="false">
                    <img :width="100" src="../../../../../public/images/landscape_icon.png" alt="imag_form-design_6" /> </a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <hr>
          </span>
        </a-form-item>

        <a-form-item label="Remarks" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
          <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formData.remark" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <p v-if="!isformData" :style="{ color: 'grey' }">Please fill out all required fields.</p>
          <a-button type="primary" :disabled="!isformData" @click="visible = true" class="mr-10">
            Submit
          </a-button>
          <a-button type="danger" @click="clearForm"> Cancel </a-button>
        </a-form-item>

      </a-form>
    </a-card>
    <a-modal title="Confirm" :visible="visible" :confirm-loading="confirmLoading" @ok="submitFormBook"
      @cancel="visible = false">
      <p>Are you sure to Submit ?</p>
    </a-modal>
  </div>
</template>

<script>
const form = {
  detail_of_design: '',
  documentation_upload_file: '',
  deadline_date: '',
  size_of_design: [
    // {
    //   sizePrinting: 'Custom',
    //   width: "",
    //   height: "",
    //   amount: "",
    //   unitType: "pixels.",
    //   isPortrait: true
  ],
  print_of_media: [
    //   {
    //   sizePrinting: 'Custom',
    //   width: "",
    //   height: "",
    //   amount: "",
    //   unitType: "cm.",
    //   isPortrait: true
  ]
  ,
  print_option: [
    //   {
    //   sizePrinting: 'Custom',
    //   width: "",
    //   height: "",
    //   amount: "",
    //   unitType: "cm.",
    //   isPortrait: true
  ],
  remark: '',
  contact_mail: '',
  contact_tel: '',
}
const formDateTimeEvent = {
  event_date_start: '',
  event_time_start: '',
  event_date_end: '',
  event_time_end: ''
}
const formSizeAndAmount =
{
  width: "",
  height: "",
  amount: ""
}
import authService from '../../../../services/authService';

export default {
  data() {
    return {
      formData: Object.assign({}, form),
      dateTimeEvent: Object.assign({}, formDateTimeEvent),
      optionSizeDigitalMedia: [
        { label: 'Plasma/Signnet (1920 x 1080 pixels.)', value: 'Plasma/Signnet' },
        { label: 'Facebook Cover Photo (820 x 312 pixels.)', value: 'Facebook Cover Photo' },
        { label: 'LG/Line (1200 x 1200 pixels.)', value: 'LG/Line' },
        { label: 'Custom', value: 'Custom' }
      ],
      optionSizePrinting: [
        { label: 'A1 59.4 x 84.1 cm.', value: 'A1' },
        { label: 'A2 42 x 59.4 cm.', value: 'A2' },
        { label: 'A3 29.7 x 44.2 cm.', value: 'A3' },
        { label: 'A4 21 x 29.7 cm.', value: 'A4' },
        { label: 'A5 14.8 x 21 cm.', value: 'A5' },
        { label: 'Custom', value: 'Custom' }
      ],
      optionUnit: [
        { label: 'cm.', value: 'cm.' },
        { label: 'inch.', value: 'inch.' },
      ],
      dataImages: [{
        id: '1',
        src: 'https://unsplash.it/200?random',
        alt: 'imag_form-design_7'
      }, {
        id: '2',
        src: 'https://unsplash.it/200?random',
        alt: 'imag_form-design_8'
      }, {
        id: '2',
        src: 'https://unsplash.it/200?random',
        alt: 'imag_form-design_9',
        disabled: true
      }],
      fileList: [],
      exmapleSizePreview: true,
      loadBtnSubmit: false,
      errorSubmit: "",
      visible: false,
      confirmLoading: false,
      curDaytBooking: 10,
      limitDayBooking: 30
    };
  },

  computed: {
    isformData() {
      if (
        this.formData.detail_of_design &&
        this.formData.deadline_date &&
        (
          this.formData.size_of_design.length > 0 ||
          this.formData.print_of_media.length > 0 ||
          this.formData.print_option.length > 0
        ) &&
        this.formData.contact_mail &&
        this.formData.contact_tel
      ) {
        if (this.formData.size_of_design.length > 0 ||
          this.formData.print_of_media.length > 0 ||
          this.formData.print_option.length > 0
        ) {
          let isFullFieldSizeDesign = !this.hasNullOrEmptyValue(this.formData.size_of_design);
          let isFullFieldSizePrint = !this.hasNullOrEmptyValue(this.formData.print_of_media);
          let isFullFieldSizePrintOption = !this.hasNullOrEmptyValue(this.formData.print_option);
          return isFullFieldSizeDesign && isFullFieldSizePrint && isFullFieldSizePrintOption
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isTimeBooking() {
      if (
        this.formData.timeStart !== "" &&
        this.formData.timeEnd !== ""
      ) {
        let start = `${this.moment(this.formData.dayStart).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formData.timeStart, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        let end = `${this.moment(this.formData.dayEnd).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formData.timeEnd, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        let ms = this.moment(start, "DD/MM/YYYY HH:mm:ss").diff(
          this.moment(end, "DD/MM/YYYY HH:mm:ss")
        );
        if (ms > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.formData = JSON.parse(JSON.stringify(form));//Object.assign({}, form);
    // Priority 1: Keycloak email
    if (this.$keycloak && this.$keycloak.authenticated && this.$keycloak.tokenParsed) {
      this.formData.contact_mail = this.$keycloak.tokenParsed.email;
    } else {
      // Priority 2: MSAL email
      const msalAccount = authService.getAccount();
      if (msalAccount) {
        this.formData.contact_mail = msalAccount.username || '';
      }
    }
    this.formData.contact_tel = this.$store.state.role.RulesUser.tel;
    console.log(this.$store.state.role.RulesUser.roles)
  },
  watch: {
    "dateTimeEvent.event_date_start"(newValue, oldValue) {
      this.dateTimeEvent.event_date_end = newValue
    }
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, { name: 'normal_login' });
  },
  methods: {
    goToMainPage() {
      this.$router
        .push({
          path: "/booking/pr/design",
        })
        .catch((err) => { });
    },
    onSelectImage(e) {
      console.log(e)
    },
    hasNullOrEmptyValue(arr) {
      return arr.some(obj => Object.values(obj).some(value => value === null || value === ''));
    },
    onChangeSizeDigitalMedia(index, data) {
      switch (data) {
        case "Plasma/Signnet":
          this.formData.size_of_design[index].width = 1920
          this.formData.size_of_design[index].height = 1080
          this.formData.size_of_design[index].unitType = "pixels."
          break;

        case "Facebook Cover Photo":
          this.formData.size_of_design[index].width = 820
          this.formData.size_of_design[index].height = 312
          this.formData.size_of_design[index].unitType = "pixels."
          break;

        case "LG/Line":
          this.formData.size_of_design[index].width = 1200
          this.formData.size_of_design[index].height = 1200
          this.formData.size_of_design[index].unitType = "pixels."
          break;


        default:
          this.formData.size_of_design[index].width = 0
          this.formData.size_of_design[index].height = 0
          this.formData.size_of_design[index].unitType = "cm."
          break;
      }
    },
    onChangeSizePrint(index, data, listPrinting) {
      switch (data) {
        case "A1":
          this.formData[listPrinting][index].width = 59.4
          this.formData[listPrinting][index].height = 84.1
          this.formData[listPrinting][index].unitType = "cm."
          break;

        case "A2":
          this.formData[listPrinting][index].width = 42
          this.formData[listPrinting][index].height = 59.4
          this.formData[listPrinting][index].unitType = "cm."
          break;

        case "A3":
          this.formData[listPrinting][index].width = 29.7
          this.formData[listPrinting][index].height = 44.2
          this.formData[listPrinting][index].unitType = "cm."
          break;

        case "A4":
          this.formData[listPrinting][index].width = 21
          this.formData[listPrinting][index].height = 29.7
          this.formData[listPrinting][index].unitType = "cm."
          break;

        case "A5":
          this.formData[listPrinting][index].width = 14.8
          this.formData[listPrinting][index].height = 21
          this.formData[listPrinting][index].unitType = "cm."
          break;

        default:
          this.formData[listPrinting][index].width = 0
          this.formData[listPrinting][index].height = 0
          this.formData[listPrinting][index].unitType = "cm."
          break;
      }
    },
    addData(fieldList) {
      this.formData[fieldList].push({
        sizePrinting: 'Custom',
        width: "",
        height: "",
        amount: "",
        unitType: "cm.",
        isPortrait: true
      })
    },
    async removeItem(index, listPrinting) {
      this.formData[listPrinting].splice(index, 1);
    },
    setVisibleSizePreview(value) {
      this.exmapleSizePreview = value;
    },
    beforeUpload(file) {
      this.errorFile = "";
      if (
        file.type === "image/jpg" ||
        file.type === "application/pdf" ||
        file.type === "image/jpeg" ||
        file.type === ".heic" ||
        file.type === "image/png"
      ) {
        this.formData.documentation_upload_file = file;
        this.fileList = [...this.fileList, file];
      } else {
        this.errorFile = "Found a Problemm, please check your results.";
      }
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    disabledDate(endEventDate) {
      let datePlus = new Date();
      let limitDate = new Date();
      // add day
      datePlus.setDate(datePlus.getDate() + this.curDaytBooking);
      limitDate.setDate(limitDate.getDate() + this.curDaytBooking + this.limitDayBooking);

      console.log(this.moment(datePlus).format("YYYY-MM-DD"))
      console.log(this.moment(limitDate).format("YYYY-MM-DD"))

      return (this.moment(endEventDate).format("YYYY-MM-DD") < this.moment(datePlus).format("YYYY-MM-DD")
        || this.moment(endEventDate).format("YYYY-MM-DD") > this.moment(limitDate).format("YYYY-MM-DD")
      )
        || (
          this.moment(endEventDate).format("dddd") === "Saturday" ||
          this.moment(endEventDate).format("dddd") === "Sunday"
        )
    },
    clearForm() {
      this.formData = JSON.parse(JSON.stringify(form));//Object.assign({}, form);
      // Priority 1: Keycloak email
      if (this.$keycloak && this.$keycloak.authenticated && this.$keycloak.tokenParsed) {
        this.formData.contact_mail = this.$keycloak.tokenParsed.email;
      } else {
        // Priority 2: MSAL email
        const msalAccount = authService.getAccount();
        if (msalAccount) {
          this.formData.contact_mail = msalAccount.username || '';
        }
      }
      this.formData.contact_tel = this.$store.state.role.RulesUser.tel;
      this.$router
        .push({
          path: "/booking/pr/design",
        })
        .catch((err) => { });
    },
    disabledHolidayDate(date) {
      if (
        this.moment(date).format("dddd") === "Saturday" ||
        this.moment(date).format("dddd") === "Sunday"
      ) {
        return true;
      }
    },
    async submitFormBook() {
      this.loadBtnSubmit = true;
      this.errorSubmit = null;
      let jsonData = { ...this.formData }

      // //set datetime event
      jsonData.deadline_date = this.moment(jsonData.deadline_date).format("YYYY-MM-DD") + "T" +
        this.moment(jsonData.deadline_date, "HH:mm:ss").format("HH:mm:ss") +
        "+07:00"

      // //Digital Media
      jsonData.size_of_design = jsonData.size_of_design.map(
        data => ({
          "height": data.height + " pixels.",
          "width": data.width + " pixels.",
          "amount": data.amount,
          "isPortrait": data.isPortrait
        })
      )
      jsonData.size_of_design = JSON.stringify(jsonData.size_of_design)

      //Print of Media
      jsonData.print_of_media = jsonData.print_of_media.map(
        data => ({
          "height": data.height + " " + data.unitType,
          "width": data.width + " " + data.unitType,
          "amount": data.amount,
          "isPortrait": data.isPortrait
        })
      )
      jsonData.print_of_media = JSON.stringify(jsonData.print_of_media)
      //JSON.parse(JSON.stringify(form));
      //Print (Option)
      jsonData.print_option = jsonData.print_option.map(
        data => ({
          "height": data.height + " " + data.unitType,
          "width": data.width + " " + data.unitType,
          "amount": data.amount,
          "isPortrait": data.isPortrait
        })
      )
      jsonData.print_option = JSON.stringify(jsonData.print_option)
      console.log(jsonData)
      try {
        // Convert json to fromData because the problem when upload a file
        // Create a new FormData object
        const formData = new FormData();
        // Loop through the keys in the JSON data and add them to the FormData object
        for (const key in jsonData) {
          formData.append(key, jsonData[key]);
        }
        const response = await this.$http.post("/booking/design/add/", formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 201) {
          this.clearForm();
          this.visible = false;
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.loadBtnSubmit = false;
        this.errorSubmit = error;
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /booking/video/add/`,
        });
      }
    },
  },
};
</script>